import { Button, Text, Group } from "@mantine/core";
import React, { useState } from "react";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import { openFileUrl } from "../utils/openReport";

const ReportIFastTransaction = () => {
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [loading, setLoading] = useState(false);
  const [api] = useServerApi();
  const { t } = useTranslation();

  const downloadReport = async () => {
    try {
      setLoading(true);
      const result = await api.OrderInvestmentTransaction.getReport({
        fromDate,
        toDate,
      });
      setLoading(false);
      if (result && result.data && result.data.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <div>
      <Text size="xs">{t("Please select the period of records.")}</Text>
      <Text size="xs">{t("Application Received Date")}</Text>
      <Group mt="xs">
        <DatePicker
          title={t("From Date")}
          size="xs"
          allowFreeInput
          placeholder="From"
          onChange={(d) => setFromDate(d)}
        />
        -
        <DatePicker
          title={t("To Date")}
          size="xs"
          allowFreeInput
          placeholder="To"
          onChange={(d) => setToDate(d)}
        />
      </Group>
      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
      >
        {t("Download")}
      </Button>
    </div>
  );
};

export default ReportIFastTransaction;
